/* global $, swal */

const UI = {
  handleChange(event, callback) {
    let name = event.target.name;
    let value = event.target.value;

    let names = event.target.name.split(".");

    if (names.length > 1) {
      let name = names[0];
      let index = 0;
      if (name.includes("[")) {
        index = parseInt(name.substring(name.lastIndexOf("[") +1, name.lastIndexOf("]")));
        name = name.substring(0, name.lastIndexOf("["));

        value = this.state[name];
        value[index][names[1]] = event.target.value;
        this.setState({ [name]: value });
      }
      else {
        value = this.state[name];
        value[names[1]] = event.target.value;
      }
    }
    
    if (callback) { callback(name, value) }
    else { this.setState({ [name]: value }); }
  },

  loader: (action, text) => {
    if (action === "show") {
      $("#loader").show();
      $("#loader-text").text(text ? text : "");
    } else {
      $("#loader").hide();
    }
  },

  toggleModal: id => {
    $(id).modal("toggle");
  },

  alert: (success, message, icon) => {
    let object = {
      text: message,
      icon: !icon ? (success ? "success" : "error") : icon,
      button: {
        text: "Entendi",
        value: true,
        visible: true,
        className: "btn " + (success ? "btn-primary" : "btn-danger")
      }
    }
    return swal(object);
  },

  confirm: (title, message, cancelText = "Cancelar", confirmText = "Tenho") => {
    let object = {
      title: title,
      text: message,
      icon: "info",
      showCancelButton: true,
      buttons: {
        cancel: {
          text: cancelText,
          value: null,
          visible: true,
          className: "btn btn-danger",
          closeModal: true,
        },
        confirm: {
          text: confirmText,
          value: true,
          visible: true,
          className: "btn btn-primary",
          closeModal: true
        }
      }
    }
    return swal(object);
  },

  inputHelpers: () => {
    $(".form-check .form-check-label,.form-radio .form-check-label")
      .not(".todo-form-check .form-check-label")
      .append('<i class="input-helper"></i>');
  },

  destroyTable: (id) => {
    if (id) {
      id = id.includes('#') ? id : "#" + id;
      $(id).dataTable().fnClearTable();
      $(id).dataTable().fnDestroy();
    }
  },

  dataTable: (id) => {
    if (id) {
      id = id.includes('#') ? id : "#" + id;
      if (!$.fn.dataTable.isDataTable(id)) {
        $(id).DataTable({
          "iDisplayLength": 10,
          "bFilter": false,
          "bLengthChange": false,
          "language": {
            "emptyTable": "Nenhum registro encontrado",
            "infoEmpty": "Página 1 de 1",
            "paginate": {
              "previous": "<",
              "next": ">"
            },
            "info": "Página _PAGE_ de _PAGES_"
          }
        });
      }
    }
  }
};

export default UI;
